export default __webpack_public_path__ + "static/media/zoo@2x.bf8dc4f1.jpg";